<main id="db-wrapper" class="bg-light">


  <!-- navbar vertical -->
  <!-- Sidebar -->
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <!-- Page Content -->
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation></app-only-admin-navigation>
    </div>

    <div class="container-fluid p-4">
      <div class="row">
        <div class="col-lg-12" *ngIf="loading">
          <app-form-spinner></app-form-spinner>
        </div>

        <div class="col-lg-12 col-md-12 col-12" *ngIf="!loading">
          <div class="card border-0 px-5 pb-7">
            <div class="card-header">
              <div class="text-center ">
                <h2 class="text-dark display-4 fw-bold">
                  {{"addNewUser" | translate}}
                </h2>
              </div>

            </div>
            <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="pt-5">
              <div class="row g-3" >
                <div class="mb-1">
                  <label for="userRole" class="form-label">
                    {{"userRole" | translate}}
                  </label>
                  <select id="userRole" class="form-control form-control-lg" formControlName="userRole">
                    <option value="" selected>Choose One</option>
                    <option value="Administrator">Administrator</option>
                    <option value="User">User</option>
                  </select>
                  <div class="error-message text-danger" *ngIf="userForm.get('userRole')?.invalid && userForm.get('userRole')?.touched">
                    User Role is Required
                  </div>
                </div>
                <div class="mb-1">
                  <label for="email" class="form-label">
                    {{'Email' | translate}}
                  </label>
                  <input type="email" id="email" class="form-control form-control-lg" formControlName="email" placeholder="Jondoe@example.com">
                  <div class="error-message text-danger" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
                    <ng-container *ngIf="userForm.get('email')?.hasError('required')">Email is Required</ng-container>
                    <ng-container *ngIf="userForm.get('email')?.hasError('email')">Email format is incorret</ng-container>
                  </div>
                </div>
                <div class="mb-1">
                  <label for="password" class="form-label">
                    {{"Password" | translate}}
                  </label>
                  <input type="password" id="password" class="form-control form-control-lg" formControlName="password" >
                  <div class="error-message text-danger" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
                    Password is Required
                  </div>
                </div>
                <div class="mb-2">
                  <label for="username" class="form-label">Username</label>
                  <div class="input-group">
                    <span class="input-group-text fw-bold">TouchConnect.com/</span>
                    <input type="text" class="form-control form-control-lg" formControlName="username" (input)="checkUsernameAvailability()">
                    <div *ngIf="usernameAvailable" class="input-group-text text-success"><i class="bi bi-check-lg"></i></div>
                    <div *ngIf="notPresent" class="input-group-text text-danger"><i class="fa-solid fa-xmark"></i></div>
                    <div *ngIf="loadUsername" class="input-group-text text-danger">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                   </div>
                  </div>
                  <div class="text-danger" *ngIf="userForm.get('username')?.hasError('required') && userForm.get('username')?.touched">
                    Username is Required
                  </div>
                </div>
                <div class="mb-3">
                  <label for="userType" class="form-label">
                    {{"userType" | translate}}
                  </label>
                  <select id="userType" class="form-control form-control-lg" formControlName="userType">
                    <option value="" selected>Choose One</option>
                    <option value="Premium">Premium</option>
                    <option value="Free">Free</option>
                  </select>
                  <div class="error-message text-danger" *ngIf="userForm.get('userType')?.invalid && userForm.get('userType')?.touched">
                    User Type is Required
                  </div>
                </div>
              </div>
              <div class="d-grid" *ngIf="loading">
                <button type="button" class="btn btn-primary btn-lg rounded-4 py-3">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
              </div>
              <div class="d-grid" *ngIf="!loading">
                <button type="submit" class="btn btn-primary btn-lg rounded-4 mb-3 py-3" [disabled]="userForm.invalid" style="background-color: rgb(80,34,116) !important;">Create Account</button>
              </div>
            </form>

          </div>
        </div>
      </div>

    </div>
  </section>
</main>
